import { createFileRoute } from "@tanstack/react-router";

import { AudiencesPanel } from "../../../../workspaces/settings/platform/AudiencesPanel";

export const Route = createFileRoute("/_console/settings/platform/audiences")({
  component: AudiencesPanel,
});
